(function () {
  'use strict';

  var containerSelector = '[data-load-more-container], [data-lukzer-load-more]';
  var buttonSelector = '[data-load-more-button], [data-lukzer-load-more-button]';
  var gridSelector = '[data-product-grid], #product-grid, #ProductGrid, .product-collection, .custom-collection-grid__grid, .subcategory-results__grid';
  var productSelector = '.product--item, .custom-collection-grid__item, .lkz-product-card, .grid__item, .product-card-wrapper';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getScopedRoot(container) {
    return container.closest('.shopify-section, section, .custom-collection-grid, .subcategory-results, #CollectionProductContainer') || document;
  }

  function getGrid(container) {
    var root = getScopedRoot(container);
    var grids = toArray(root.querySelectorAll(gridSelector)).filter(function (grid) {
      return grid && grid !== container && !container.contains(grid);
    });

    if (grids.length) {
      var beforeContainer = grids.filter(function (grid) {
        return Boolean(grid.compareDocumentPosition(container) & Node.DOCUMENT_POSITION_FOLLOWING);
      });
      return beforeContainer[beforeContainer.length - 1] || grids[0];
    }

    var parent = container.parentElement;
    while (parent && parent !== document.body) {
      var localGrid = parent.querySelector(gridSelector);
      if (localGrid && localGrid !== container && !container.contains(localGrid)) return localGrid;
      parent = parent.parentElement;
    }

    return document.querySelector(gridSelector);
  }

  function getProductCards(grid) {
    return toArray(grid ? grid.querySelectorAll(productSelector) : []).filter(function (card) {
      return card && !card.matches('template, script, style, .hide, [hidden]');
    });
  }

  function getIdentifier(card) {
    if (!card) return '';
    var productNode = card.matches('[data-product-id], [data-product-handle]') ? card : card.querySelector('[data-product-id], [data-product-handle]');
    var id = productNode && (productNode.dataset.productId || productNode.dataset.productHandle);
    if (id) return String(id);
    var link = card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : '';
  }

  function makeUrl(url) {
    return new URL(url, window.location.origin).toString();
  }

  function findMatchingGrid(fetchedDocument, currentGrid) {
    var sectionId = currentGrid && (currentGrid.dataset.sectionId || currentGrid.dataset.id);
    if (sectionId) {
      var sectionGrid = fetchedDocument.querySelector('[data-section-id="' + CSS.escape(sectionId) + '"][data-product-grid], [data-id="' + CSS.escape(sectionId) + '"][data-product-grid]');
      if (sectionGrid) return sectionGrid;
    }

    if (currentGrid && currentGrid.id) {
      var idGrid = fetchedDocument.getElementById(currentGrid.id);
      if (idGrid) return idGrid;
    }

    var currentClass = currentGrid && toArray(currentGrid.classList).find(function (className) {
      return /product|collection|grid|loadmore/.test(className);
    });
    if (currentClass) {
      var classGrid = fetchedDocument.querySelector('[data-product-grid].' + CSS.escape(currentClass) + ', .' + CSS.escape(currentClass));
      if (classGrid) return classGrid;
    }

    return fetchedDocument.querySelector(gridSelector);
  }

  function findFetchedContainer(fetchedDocument, currentContainer) {
    if (currentContainer.id) {
      var byId = fetchedDocument.getElementById(currentContainer.id);
      if (byId) return byId;
    }

    var currentClass = toArray(currentContainer.classList).find(function (className) {
      return /loadmore|load-more|pagination/.test(className);
    });
    if (currentClass) {
      var byClass = fetchedDocument.querySelector(containerSelector + '.' + CSS.escape(currentClass) + ', .' + CSS.escape(currentClass) + containerSelector);
      if (byClass) return byClass;
    }

    return fetchedDocument.querySelector(containerSelector);
  }

  function refreshShiprocketWidgets(scope) {
    document.dispatchEvent(new CustomEvent('collection:products-appended', {
      detail: { container: scope }
    }));

    if (window.SRCheckout && typeof window.SRCheckout.init === 'function') {
      window.SRCheckout.init();
    }
    if (window.shiprocketMarketing && typeof window.shiprocketMarketing.init === 'function') {
      window.shiprocketMarketing.init();
    }
    if (window.avadaAirReviewRerender) {
      window.avadaAirReviewRerender();
    }
  }

  function CollectionLoadMore(container) {
    if (!container || container.dataset.lukzerLoadMoreInitialized === 'true') return;
    this.container = container;
    this.button = container.querySelector(buttonSelector);
    this.grid = getGrid(container);
    if (!this.button || !this.grid) return;

    this.label = this.button.querySelector('[data-load-more-label], [data-lukzer-load-more-label]') || this.button.querySelector('span');
    this.spinner = this.button.querySelector('[data-load-more-spinner]');
    this.error = container.querySelector('[data-load-more-error], .lukzer-load-more__error, .loadmore-error');
    this.count = container.querySelector('.lukzer-load-more__count, .pagination__count, .loadmore-count');
    this.loadedCount = container.querySelector('[data-loaded-count], .count');
    this.totalCount = container.querySelector('[data-total-count], .total');
    this.progress = container.querySelector('[role="progressbar"], .lukzer-load-more__progress, .pagination__bar, .progress-bar');
    this.progressBar = container.querySelector('[data-progress-bar], .lukzer-load-more__progress-fill, .progress');
    this.defaultLabel = this.button.dataset.defaultLabel || (this.label ? this.label.textContent.trim() : 'LOAD MORE PRODUCTS');
    this.isLoading = false;
    this.onClick = this.onClick.bind(this);
    this.container.dataset.lukzerLoadMoreInitialized = 'true';
    this.button.addEventListener('click', this.onClick);
    this.updateProgress();
  }

  CollectionLoadMore.prototype.getNextUrl = function () {
    return this.button.dataset.nextUrl || this.container.dataset.nextUrl || this.grid.dataset.nextUrl || '';
  };

  CollectionLoadMore.prototype.setNextUrl = function (nextUrl) {
    if (nextUrl) {
      this.button.dataset.nextUrl = nextUrl;
      this.container.dataset.nextUrl = nextUrl;
      this.grid.dataset.nextUrl = nextUrl;
    } else {
      delete this.button.dataset.nextUrl;
      delete this.container.dataset.nextUrl;
      delete this.grid.dataset.nextUrl;
    }
  };

  CollectionLoadMore.prototype.setLoading = function (isLoading) {
    this.isLoading = isLoading;
    this.button.disabled = isLoading;
    this.button.classList.toggle('is-loading', isLoading);
    this.button.classList.toggle('loading', isLoading);
    this.button.setAttribute('aria-busy', String(isLoading));
    if (this.spinner) this.spinner.hidden = !isLoading;
    if (this.label) this.label.textContent = isLoading ? 'LOADING PRODUCTS...' : this.defaultLabel;
  };

  CollectionLoadMore.prototype.showError = function () {
    if (!this.error) return;
    this.error.textContent = 'Unable to load products. Please try again.';
    this.error.hidden = false;
  };

  CollectionLoadMore.prototype.hideError = function () {
    if (!this.error) return;
    this.error.textContent = '';
    this.error.hidden = true;
  };

  CollectionLoadMore.prototype.getTotal = function () {
    return Number(this.container.dataset.totalProducts || this.container.dataset.total || (this.totalCount && this.totalCount.textContent.trim()) || 0);
  };

  CollectionLoadMore.prototype.getLoaded = function () {
    return getProductCards(this.grid).length || Number(this.container.dataset.loadedProducts || 0);
  };

  CollectionLoadMore.prototype.updateStatus = function (loaded, total, complete) {
    var safeTotal = Math.max(total || 0, 0);
    var safeLoaded = safeTotal > 0 ? Math.min(loaded, safeTotal) : loaded;
    this.container.dataset.loadedProducts = String(safeLoaded);
    if (this.loadedCount) this.loadedCount.textContent = String(safeLoaded);
    if (this.totalCount) this.totalCount.textContent = String(safeTotal);
    if (this.count && (!this.loadedCount || !this.totalCount)) {
      this.count.innerHTML = complete
        ? '&#10003; All <strong class="total" data-total-count>' + safeTotal + '</strong> products loaded'
        : 'Showing <strong class="count" data-loaded-count>' + safeLoaded + '</strong> of <strong class="total" data-total-count>' + safeTotal + '</strong> products';
      this.loadedCount = this.container.querySelector('[data-loaded-count], .count');
      this.totalCount = this.container.querySelector('[data-total-count], .total');
    }
    this.updateProgress(safeLoaded, safeTotal);
  };

  CollectionLoadMore.prototype.updateProgress = function (loaded, total) {
    var safeLoaded = typeof loaded === 'number' ? loaded : Number(this.container.dataset.loadedProducts || (this.loadedCount && this.loadedCount.textContent.trim()) || this.getLoaded());
    var safeTotal = typeof total === 'number' ? total : this.getTotal();
    var percentage = safeTotal > 0 ? Math.min((safeLoaded / safeTotal) * 100, 100) : 0;
    if (this.progressBar) this.progressBar.style.width = percentage + '%';
    if (this.progress) {
      this.progress.setAttribute('aria-valuenow', String(Math.min(safeLoaded, safeTotal || safeLoaded)));
      if (safeTotal) this.progress.setAttribute('aria-valuemax', String(safeTotal));
    }
  };

  CollectionLoadMore.prototype.finish = function () {
    var total = this.getTotal();
    this.container.classList.add('is-complete', 'collection-load-more--complete');
    this.button.hidden = true;
    this.updateStatus(total || this.getLoaded(), total, true);
  };

  CollectionLoadMore.prototype.onClick = async function (event) {
    event.preventDefault();
    if (this.isLoading) return;

    var nextUrl = this.getNextUrl();
    if (!nextUrl) {
      this.finish();
      return;
    }

    this.setLoading(true);
    this.hideError();

    try {
      var response = await fetch(makeUrl(nextUrl), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error('Request failed: ' + response.status);

      var html = await response.text();
      if (!html.trim()) throw new Error('Empty response received');

      var fetchedDocument = new DOMParser().parseFromString(html, 'text/html');
      var fetchedGrid = findMatchingGrid(fetchedDocument, this.grid);
      if (!fetchedGrid) throw new Error('Product grid not found in fetched page');

      var fetchedProducts = getProductCards(fetchedGrid);
      if (!fetchedProducts.length) throw new Error('No product cards found in fetched page');

      var existingIdentifiers = new Set(getProductCards(this.grid).map(getIdentifier).filter(Boolean));
      var fragment = document.createDocumentFragment();
      var appended = [];

      fetchedProducts.forEach(function (card) {
        var identifier = getIdentifier(card);
        if (identifier && existingIdentifiers.has(identifier)) return;
        if (identifier) existingIdentifiers.add(identifier);
        var importedCard = document.importNode(card, true);
        importedCard.classList.add('lukzer-load-more__new-card', 'load-more-product-enter');
        importedCard.style.setProperty('--load-more-index', String(appended.length));
        fragment.appendChild(importedCard);
        appended.push(importedCard);
      });

      if (!appended.length) throw new Error('No unique products were available to append');

      this.grid.appendChild(fragment);
      requestAnimationFrame(function () {
        appended.forEach(function (card) {
          card.classList.add('load-more-product-enter--active');
        });
      });

      var fetchedContainer = findFetchedContainer(fetchedDocument, this.container);
      var newNextUrl = (fetchedContainer && fetchedContainer.dataset.nextUrl) ||
        (fetchedContainer && fetchedContainer.querySelector(buttonSelector) && fetchedContainer.querySelector(buttonSelector).dataset.nextUrl) ||
        (fetchedGrid && fetchedGrid.dataset.nextUrl) ||
        '';

      this.setNextUrl(newNextUrl);

      var total = this.getTotal();
      var loaded = this.getLoaded();
      var complete = !newNextUrl || (total > 0 && loaded >= total);
      this.updateStatus(loaded, total, complete);
      refreshShiprocketWidgets(this.grid);

      if (complete) this.finish();
    } catch (error) {
      console.error('[Load More Products]', error);
      this.showError();
    } finally {
      this.setLoading(false);
    }
  };

  CollectionLoadMore.prototype.destroy = function () {
    if (this.button) this.button.removeEventListener('click', this.onClick);
    if (this.container) delete this.container.dataset.lukzerLoadMoreInitialized;
  };

  function initializeCollectionLoadMore(scope) {
    if (window.jQuery) {
      window.jQuery(document.body).off('click.lukzerLoadMore');
      window.jQuery('.collection__btn-loadmore, .btn_loadmore, [data-lukzer-load-more-button]').off('click.lukzerLoadMore');
    }
    toArray((scope || document).querySelectorAll(containerSelector)).forEach(function (container) {
      new CollectionLoadMore(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeCollectionLoadMore(document);
    });
  } else {
    initializeCollectionLoadMore(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeCollectionLoadMore(event.target);
  });

  document.addEventListener('lukzer:products-updated', function (event) {
    initializeCollectionLoadMore(event.target || document);
  });

  window.LukzerCollectionLoadMore = {
    init: initializeCollectionLoadMore
  };
})();
